export default {
  SESS_STORAGE_CUSTOMER_INFO_KEY: 'CUSTOMER_INFO_FORM_DATA',
  SESS_STORAGE_APPLICATION_KEY: 'APPLICATION',
  SESS_STORAGE_RELATIONSHIP_KEY: 'RELATIONSHIP',
};
